<template>
    <div v-if="planningItem !== null">
        <md-button @click="goBack()" id="back-btn">
            <md-icon>keyboard_arrow_left</md-icon>
            back
        </md-button>
        <div>
            <div class="md-headline">{{ planningType }} - {{ planningItem.planning_item_type_number }}</div>
            {{
                planningItem.client
                    ? (planningItem.client.first_name ? planningItem.client.first_name : '-') +
                      ' ' +
                      (planningItem.client.last_name ? planningItem.client.last_name : '-')
                    : planningItem.lead.data
                    ? planningItem.lead.data.first_name + ' ' + planningItem.lead.data.last_name
                    : ''
            }}
            <div class="md-layout-item">
                <md-field>
                    <label for="actie">Actie</label>
                    <md-select id="actie" name="actie" required v-model="selectedAction">
                        <md-option :key="index" :value="action.value" v-for="(action, index) in actionOptions"
                            >{{ action.text }}
                        </md-option>
                    </md-select>
                </md-field>
                <md-field
                    v-if="
                        planningType !== PlanningItemType.lead &&
                        selectedAction === PlanningItemReportState.completed &&
                        configuration?.planning.paymentMethod
                    "
                >
                    <label for="payment_method">Betaal methode</label>
                    <md-select id="payment_method" name="payment_method" required v-model="paymentMethod">
                        <md-option :key="index" :value="option" v-for="(option, index) in paymentMethodTypes">
                            {{ parsePaymentMethodTypeReadable(option) }}
                        </md-option>
                    </md-select>
                </md-field>
                <md-field>
                    <label>Commentaar</label>
                    <md-textarea id="report-comment" required v-model="reportComment"></md-textarea>
                </md-field>
                <md-button
                    v-if="workOrderEnabled"
                    @click="finishWithWorkOrder()"
                    class="md-primary"
                    id="btn-finish-work-order"
                    >Afwerken met werkbon</md-button
                >
                <md-button @click="submitReport()" class="md-primary md-raised" id="btn-submit">Verstuur</md-button>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { PlanningParameters } from '@/services/manager/planning.manager';
import PlanningCard from '@/components/PlanningCard.vue';
import router from '@/router';
import * as toastr from 'toastr';
import {
    IConfiguration,
    IPlanningItemEntity,
    PaymentMethodType,
    PlanningItemApi,
    PlanningItemReportState,
    PlanningItemType,
} from '@phrospr/api-backend';
import { getEnumKeys } from '@phrospr/lib-core/src/engine/enum.engine';
import {
    getReportActionOptions,
    parsePaymentMethodTypeReadable,
} from '@phrospr/lib-core/src/engine/planning-item.engine';
import { workOrderEnabledForPlanningType } from '@phrospr/lib-core/src/engine/work-order.engine';

@Component({
    components: { PlanningCard },
})
export default class PlanningFinishView extends Vue {
    reportComment: string = '';
    actionOptions: Array<{ text: string; value: PlanningItemReportState }> = [];
    selectedAction: string = '';
    @Prop() private calendarItemId: number;

    paymentMethod: PaymentMethodType = PaymentMethodType.CASH;
    paymentMethodTypes = getEnumKeys(PaymentMethodType);

    PlanningItemType = PlanningItemType;
    PlanningItemReportState = PlanningItemReportState;

    constructor() {
        super();
        this.loadPlanningItem();
    }

    get configuration(): Partial<IConfiguration> {
        return this.$store.state.configuration;
    }

    get planningType() {
        return this.planningItem.planning_item_type;
    }

    get clientName() {
        return this.planningItem.client.client_data.first_name + ' ' + this.planningItem.client.client_data.last_name;
    }

    get planningItem(): IPlanningItemEntity {
        return this.$store.state.planningItem;
    }

    public async loadPlanningItem() {
        try {
            await this.$store.dispatch('getPlanningDetailFromCalendarItemId', this.calendarItemId);
            this.actionOptions = getReportActionOptions(this.planningItem.planning_item_type);
        } catch (err) {
            console.error(err);
        }
    }

    public goBack() {
        PlanningParameters.listDate = new Date(this.planningItem.selected_calendar_item.date_time_start);
        router.push('/planning');
    }

    get workOrderEnabled(): boolean {
        return workOrderEnabledForPlanningType(this.configuration?.workOrders, this.planningItem.planning_item_type);
    }

    // Escape hatch to the work-order flow: registers products/time and
    // auto-completes this planning item on save.
    public finishWithWorkOrder() {
        this.$store.commit('setWorkOrderCreateSettings', {
            client: this.planningItem.client,
            planningItem: this.planningItem,
        });
        router.push({ path: `/workOrder/upsert` });
    }

    public parsePaymentMethodTypeReadable(paymentMethod: PaymentMethodType) {
        return parsePaymentMethodTypeReadable(paymentMethod);
    }

    public async submitReport() {
        if (!this.selectedAction || !this.reportComment) {
            return toastr.error('Gelieve alle velden in te vullen!');
        }
        // fixme submit report
        try {
            await PlanningItemApi.finishPlanningItem({
                calendarItemID: this.calendarItemId,
                comment: this.reportComment,
                action: this.selectedAction as PlanningItemReportState,
                paymentMethod: this.paymentMethod,
            });
            this.goBack();
        } catch (err) {
            console.log(err);
            toastr.error('Something went wrong!');
        }
    }
}
</script>

<style scoped>
#report-comment {
    min-height: 200px;
}

#btn-submit {
    float: right;
}
</style>
